import { axiosInstance } from "./AxiosConfiguration";

export async function getPresignedURL() {
    try {
        const response = await axiosInstance.get('/api/v1/upload/url');
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export async function putAudioIntoPresigned(presignedFields, audioBlob) {
    const formData = new FormData();

    Object.keys(presignedFields['fields']).forEach(key => {
        formData.append(key, presignedFields['fields'][key]);
    })

    formData.append('file', audioBlob);

    try {
        const response = await fetch(presignedFields.url, {
            method: 'POST',
            body: formData,
        })
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('File successfully uploaded');

        return response;
    } catch (error) {
        console.error('Error uploading file:', error);
    }
}